<template>
    <div id="chartdiv2"></div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import API from '@/api'

    export default {
        props: ['date_from', 'date_to', 'projectID'],
        data() {
            return {
                form: {
                    date_from: '',
                    date_to: '',
                    client_id: '',
                    projectID: ''
                },
                datacollection: {
                    labels: [],
                    datasets: [{
                        data: [],
                    }]
                },
                // options: {
                //     responsive: true,
                //     animation: {
                //         animateScale: true,
                //         animateRotate: true
                //     }
                // }
            }
        },
        beforeMount() {
            this.form.date_from = this.date_from;
            this.form.date_to = this.date_to;
            this.selected_client_id = JSON.parse(localStorage.getItem('client_id'));
            this.form.client_id = this.selected_client_id;
            this.getChartData();
        },
        // watch: {
        //     'datacollection'(to, from) {
        //         this.renderChart(this.datacollection, this.options)
        //         // this.$data._chart
        //     }
        // },
        mounted() {
            // this.renderChart(this.datacollection, this.options)
            this.form.projectID = this.projectID;
        },
        created() {
            // this.$EventBus.$on("filterByDate", (data) => {
            //     this.getFormData(data);
            // });
            // this.$EventBus.$on("resetForm", (data) => {
            //     this.getFormData(data);
            // });
        },
        watch: {
            projectID(newProjectID){
                if(newProjectID){
                    this.getChartData();
                }
            }
        },
        methods: {
            getFormData(data) {
                this.form.date_from = data.date_from;
                this.form.date_to = data.date_to;
                this.form.projectID = data.project_id || this.projectID;
                this.updateChartData()
            },
            getChartData() {
                this.form.date_from = this.date_from || this.form.date_from;
                this.form.date_to = this.date_to || this.form.date_to;
                this.form.projectID = this.projectID;
                API.getCategoryPerType(this.form,
                    data => {
                        var sportArray = data.data
                        var chart = am4core.create("chartdiv2", am4charts.PieChart);
                        if(chart.logo){
                            chart.logo.disabled = true;
                        }
                        chart.data = sportArray;
                        var pieSeries = chart.series.push(new am4charts.PieSeries());
                        pieSeries.dataFields.value = "spot_count";
                        pieSeries.dataFields.category = "category_name";
                        // chart.events.on("ready", function(ev){
                        //     hideIndicator();
                        // });

                        // let indicator;
                        // let indicatorInterval;

                        // function showIndicator() {
                        // if (!indicator) {
                        //     indicator = chart.tooltipContainer.createChild(am4core.Container);
                        //     indicator.background.fill = am4core.color("#fff");
                        //     indicator.width = am4core.percent(100);
                        //     indicator.height = am4core.percent(100);

                        //     var indicatorLabel = indicator.createChild(am4core.Label);
                        //     indicatorLabel.text = "Loading ...";
                        //     indicatorLabel.align = "center";
                        //     indicatorLabel.valign = "middle";
                        //     indicatorLabel.dy = 50;
                            
                        //     var hourglass = indicator.createChild(am4core.Image);
                        //     hourglass.href = "https://s3-us-west-2.amazonaws.com/s.cdpn.io/t-160/hourglass.svg";
                        //     hourglass.align = "center";
                        //     hourglass.valign = "middle";
                        //     hourglass.horizontalCenter = "middle";
                        //     hourglass.verticalCenter = "middle";
                        //     hourglass.scale = 0.4;
                        // }

                        // indicator.hide(0);
                        // indicator.show();

                        // clearInterval(indicatorInterval);
                        // indicatorInterval = setInterval(function() {
                        //     hourglass.animate([{
                        //     from: 0,
                        //     to: 360,
                        //     property: "rotation"
                        //     }], 2000);
                        // }, 3000);
                        // }

                        // function hideIndicator() {
                        // indicator.hide();
                        // clearInterval(indicatorInterval);
                        // }

                        // showIndicator();
                        pieSeries.ticks.template.disabled = true;
                        pieSeries.alignLabels = false;
                        // pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";
                        pieSeries.labels.template.text = "{value}";
                        pieSeries.labels.template.radius = am4core.percent(-40);
                        pieSeries.labels.template.fill = am4core.color("white");
                        chart.legend = new am4charts.Legend();
                        chart.legend.position = "right";
                        chart.legend.scrollable = true;
                        chart.responsive.enabled = true;

                        window.addEventListener('resize', () => {
                            if (window.innerWidth <= 1199) {
                                chart.legend.position = "bottom";
                            } else {
                                chart.legend.position = "right";
                            }
                        }, true);
                    },
                    err => {
                    }
                )
            },
            updateChartData() {
                API.getCategoryPerType(this.form,
                    data => {
                        var sportArray = data.data
                        var chart = am4core.create("chartdiv2", am4charts.PieChart);
                        if(chart.logo){
                            chart.logo.disabled = true;
                        }
                        chart.data = sportArray;
                        var pieSeries = chart.series.push(new am4charts.PieSeries());
                        pieSeries.dataFields.value = "spot_count";
                        pieSeries.dataFields.category = "category_name";
                        // chart.events.on("ready", function(ev){
                        //     hideIndicator();
                        // });

                        // let indicator;
                        // let indicatorInterval;

                        // function showIndicator() {
                        // if (!indicator) {
                        //     indicator = chart.tooltipContainer.createChild(am4core.Container);
                        //     indicator.background.fill = am4core.color("#fff");
                        //     indicator.width = am4core.percent(100);
                        //     indicator.height = am4core.percent(100);

                        //     var indicatorLabel = indicator.createChild(am4core.Label);
                        //     indicatorLabel.text = "Loading ...";
                        //     indicatorLabel.align = "center";
                        //     indicatorLabel.valign = "middle";
                        //     indicatorLabel.dy = 50;
                            
                        //     var hourglass = indicator.createChild(am4core.Image);
                        //     hourglass.href = "https://s3-us-west-2.amazonaws.com/s.cdpn.io/t-160/hourglass.svg";
                        //     hourglass.align = "center";
                        //     hourglass.valign = "middle";
                        //     hourglass.horizontalCenter = "middle";
                        //     hourglass.verticalCenter = "middle";
                        //     hourglass.scale = 0.4;
                        // }

                        // indicator.hide(0);
                        // indicator.show();

                        // clearInterval(indicatorInterval);
                        // indicatorInterval = setInterval(function() {
                        //     hourglass.animate([{
                        //     from: 0,
                        //     to: 360,
                        //     property: "rotation"
                        //     }], 2000);
                        // }, 3000);
                        // }

                        // function hideIndicator() {
                        // indicator.hide();
                        // clearInterval(indicatorInterval);
                        // }

                        // showIndicator();
                        pieSeries.ticks.template.disabled = true;
                        pieSeries.alignLabels = false;
                        // pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";
                        pieSeries.labels.template.text = "{value}";
                        pieSeries.labels.template.radius = am4core.percent(-40);
                        pieSeries.labels.template.fill = am4core.color("white");
                        chart.legend = new am4charts.Legend();
                        chart.legend.position = "right";
                        chart.legend.scrollable = true;
                        chart.responsive.enabled = true;

                        window.addEventListener('resize', () => {
                            if (window.innerWidth <= 1199) {
                                chart.legend.position = "bottom";
                            } else {
                                chart.legend.position = "right";
                            }
                        }, true);

                        // chart.responsive.rules.push({
                        //     relevant: function(target) {
                        //         if (target.pixelWidth <= 510) {
                        //         return true;
                        //         }
                        //         return false;
                        //     },
                        //     state: function(target, stateId) {
                        //         if (target instanceof am4charts.Legend) {
                        //         var state = target.states.create(stateId);
                        //         state.properties.position = "bottom";
                                
                        //         var labelState = target.labels.template.states.create(stateId);
                        //         labelState.properties.maxWidth = 70;
                        //         labelState.properties.truncate = true;
                        //         return state;
                        //         }
                        //         return null;
                        //     }
                        // });
                    },
                    err => {
                    }
                )
            },
        }
    }
</script>

<style >
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

#chartdiv2{
  width: 100%;
  height: 330px;
}

@media (max-width: 480px) {
    #chartdiv2{
        height: 350px;
    }
}

.amcharts-chartdiv2 a {display:none !important;}
</style>